export const forbundOptions = [
  {
    label: 'Midt Norge Sør Bedriftsidrett',
    value: 'Midt Norge Sør Bedriftsidrett',
  },
  {
    label: 'NIF Barneidrett, alle barn under 13 år',
    value: 'NIF Barneidrett, alle barn under 13 år',
  },
  { label: 'Norges Bandyforbund', value: 'Norges Bandyforbund' },
  { label: 'Norges Bokseforbund', value: 'Norges Bokseforbund' },
  { label: 'Norges Bordtennisforbund', value: 'Norges Bordtennisforbund' },
  { label: 'Norges Bryteforbund', value: 'Norges Bryteforbund' },
  { label: 'Norges Bueskytterforbund', value: 'Norges Bueskytterforbund' },
  { label: 'Norges Cricketforbund', value: 'Norges Cricketforbund' },
  { label: 'Norges Danseforbund', value: 'Norges Danseforbund' },
  { label: 'Norges Fotballforbund', value: 'Norges Fotballforbund' },
  { label: 'Norges Friidrettsforbund', value: 'Norges Friidrettsforbund' },
  { label: 'Norges Ishockeyforbund', value: 'Norges Ishockeyforbund' },
  { label: 'Norges Judoforbund', value: 'Norges Judoforbund' },
  { label: 'Norges Klatreforbund', value: 'Norges Klatreforbund2' },
  {
    label: 'Norges Livredningsselskap',
    value: 'Norges Livredningsselskap',
  },
  {
    label: 'Norges Orienteringsforbund',
    value: 'Norges Orienteringsforbund',
  },
  { label: 'Norges Padleforbund', value: 'Norges Padleforbund' },
  { label: 'Norges Roforbund', value: 'Norges Roforbund' },
  { label: 'Norges Rugbyforbund', value: 'Norges Rugbyforbund' },
  { label: 'Norges Skiforbund', value: 'Norges Skiforbund' },
  { label: 'Norges Skiskytterforbund', value: 'Norges Skiskytterforbund' },
  { label: 'Norges Skøyteforbund', value: 'Norges Skøyteforbund' },
  { label: 'Norges Svømmeforbund', value: 'Norges Svømmeforbund' },
  { label: 'Norges Triatlonforbund', value: 'Norges Triatlonforbund' },
  {
    label: 'Norges Vannski- og Wakeboardforbund',
    value: 'Norges Vannski- og Wakeboardforbund',
  },
  {
    label: 'Oslo Bedriftsidrettskrets',
    value: 'Oslo Bedriftsidrettskrets',
  },
];

export const forbundUIHSOptions = [
  {
    label: 'Brettforbundet',
    value: 'Brettforbundet',
  },
  {
    label: 'NAIF Amerikansk fotball',
    value: 'NAIF Amerikansk fotball',
  },
  { label: 'NAIF Cheerleading', value: 'NAIF Cheerleading' },
  { label: 'NAIF Disksport', value: 'NAIF Disksport' },
  { label: 'NAIF Lacrosse', value: 'NAIF Lacrosse' },
  { label: 'Norges Badmintonforbund', value: 'Norges Badmintonforbund' },
  { label: 'Norges Basketballforbund', value: 'Norges Basketballforbund' },
  { label: 'Norges Bowlingforbund', value: 'Norges Bowlingforbund' },
  { label: 'Norges Cykleforbund', value: 'Norges Cykleforbund' },
  { label: 'Norges Danseforbund', value: 'Norges Danseforbund' },
  { label: 'Norges Dykkerforbund', value: 'Norges Dykkerforbund' },
  { label: 'Norges Fekteforbund', value: 'Norges Fekteforbund' },
  {
    label: 'Norges Functional Fitnessforbund (NOR3F)',
    value: 'Norges Functional Fitnessforbund (NOR3F)',
  },
  {
    label: 'Norges Gymnastikk- og Turnforbund',
    value: 'Norges Gymnastikk- og Turnforbund',
  },
  {
    label: 'Norges Hundekjørerforbund',
    value: 'Norges Hundekjørerforbund',
  },
  {
    label: 'Norges Håndballforbund',
    value: 'Norges Håndballforbund',
  },
  { label: 'Norges Skiforbund', value: 'Norges Skiforbund' },
  { label: 'Norges Squashforbund', value: 'Norges Squashforbund' },
  { label: 'Norges Volleyballforbund', value: 'Norges Volleyballforbund' },
];

export const fylkeOptions = [
  { label: 'Oslo', value: 'Oslo' },
  { label: 'Viken', value: 'Viken' },
  { label: 'Innlandet', value: 'Innlandet' },
  { label: 'Vestfold og Telemark', value: 'Vestfold og Telemark' },
  { label: 'Agder', value: 'Agder' },
  { label: 'Rogaland', value: 'Rogaland' },
  { label: 'Vestland', value: 'Vestland' },
  { label: 'Møre og Romsdal', value: 'Møre og Romsdal' },
  { label: 'Trøndelag', value: 'Trøndelag' },
  { label: 'Nordland', value: 'Nordland' },
  { label: 'Troms og Finnmark', value: 'Troms og Finnmark' },
];

export const skadetKroppsdelOptions = [
  { label: 'Hode/ansikt', value: 'Hode/ansikt' },
  { label: 'Hals/nakke', value: 'Hals/nakke' },
  { label: 'Bryst/lunger', value: 'Bryst/lunger' },
  { label: 'Buk/mage/indre organer', value: 'Buk/mage/indre organer' },
  { label: 'Rygg', value: 'Rygg' },
  { label: 'Bekken/bein', value: 'Bekken/bein' },
  { label: 'Armer/skuldre', value: 'Armer/skuldre' },
];

export const typeUnderlagOptions = [
  { label: 'Utendørs', value: 'Utendørs' },
  { label: 'Styrkerom/treningsstudio', value: 'Styrkerom/treningsstudio' },
  { label: 'Parkett', value: 'Parkett' },
  { label: 'Kunstdekke', value: 'Kunstdekke' },
  { label: 'Vann', value: 'Vann' },
  { label: 'Snø/is', value: 'Snø/is' },
  { label: 'Annet', value: 'Annet' },
];

export const occupationalInjuryEquinor = [
  {
    label: 'Occupational illness (Worker’s compensation)',
    value: 'Occupational illness (Worker’s compensation)',
  },
  {
    label: 'Other injury – Leisure-time injury',
    value: 'Other injury – Leisure-time injury',
  },
  { label: 'Other illness', value: 'Other illness' },
  { label: 'Loss of Licence', value: 'Loss of Licence' },
  {
    label: 'Co-insured spouse/cohabitant of expat',
    value: 'Co-insured spouse/cohabitant of expat',
  },
  {
    label: 'Co-insured child of expat',
    value: 'Co-insured child of expat',
  },
];

export const travelPurposeOptions = [
  { label: 'Leisure', value: 'Leisure' },
  { label: 'Business', value: 'Business' },
  { label: 'Combined leisure/business', value: 'Combined leisure/business' },
];

export const cancellationReasonOptions = [
  { label: 'Illness or injury', value: 'Illness or injury' },
  { label: 'Death', value: 'Death' },
  { label: 'Pregnancy complications', value: 'Pregnancy complications' },
  { label: 'Strike/bankruptcy', value: 'Strike/bankruptcy' },
  { label: 'Divorce or separation', value: 'Divorce or separation' },
  { label: 'Other', value: 'Other' },
];

export const cancellationOccurance = [
  { label: 'Before the trip was booked', value: 'Before the trip was booked' },
  { label: 'After the trip was booked', value: 'After the trip was booked' },
];

export const insuredTypeOptions = [
  {
    label: 'Employee / retired employee',
    value: 'Employee / retired employee',
  },
  { label: 'Co-insured family member', value: 'Co-insured family member' },
];

export const insuranceUserOptions = [
  { label: 'Myself (Equinor employee)', value: 'Myself (Equinor employee)' },
  {
    label: 'Spouse or partner with joint address',
    value: 'Spouse or partner with joint address',
  },
  {
    label: 'Child, foster child or stepchild',
    value: 'Child, foster child or stepchild',
  },
  { label: 'Other person', value: 'Other person' },
];

export const luggageDelayOccurOptions = [
  { label: 'On the outbound trip', value: 'On the outbound trip' },
  { label: 'On the return trip', value: 'On the return trip' },
];

export const delayOrCancellationCauses = [
  { label: 'Weather related reasons', value: 'Weather related reasons' },
  { label: 'Avalanche/landslides', value: 'Avalanche/landslides' },
  {
    label: 'Technical/mechanical issues',
    value: 'Technical/mechanical issues',
  },
  { label: 'Traffic accident', value: 'Traffic accident' },
  { label: 'Strike/lockout', value: 'Strike/lockout' },
  { label: 'Other', value: 'Other' },
];

export const delayDurationOptions = [
  { label: 'Less than 1,5 hours', value: 'Less than 1,5 hours' },
  { label: 'More than 1,5 hours', value: 'More than 1,5 hours' },
];

export const yesOrNo = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const jaNeiOptions = [
  { label: 'Ja', value: 'Ja' },
  { label: 'Nei', value: 'Nei' },
];

export const damagedOrLostBelongingsCauses = [
  { label: 'Theft/burglary', value: 'Theft/burglary' },
  {
    label: 'Loss of personal belongings',
    value: 'Loss of personal belongings',
  },
  {
    label: 'Damaged personal belongings',
    value: 'Damaged personal belongings',
  },
  {
    label: 'Checked-luggage (loss/damage)',
    value: 'Checked-luggage (loss/damage)',
  },
  { label: 'Other', value: 'Other' },
];

export const changeReturnTimeDateOptions = [
  { label: 'No', value: 'No' },
  {
    label: 'Yes, I travelled home earlier than planned',
    value: 'Yes, I travelled home earlier than planned',
  },
  {
    label: 'Yes, I travelled home later than planned',
    value: 'Yes, I travelled home later than planned',
  },
];

export const formLanguageOptions = [
  { label: 'Norsk', value: 'Norsk' },
  { label: 'Engelsk', value: 'Engelsk' },
];

export const numberOfFormsOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
];

export const accidentRelationOptions = [
  {
    label: 'Employee/former employee in Equinor',
    value: 'Employee/former employee in Equinor',
  },
  {
    label: 'Substitutes/other personnel',
    value: 'Substitutes/other personnel',
  },
  {
    label: 'Co-insured spouse/cohabitant or child of expat',
    value: 'Co-insured spouse/cohabitant or child of expat',
  },
];

export const deceasedOptions = [
  { label: 'Employee', value: 'Employee' },
  {
    label: 'Co-insured spouse/cohabitant',
    value: 'Co-insured spouse/cohabitant',
  },
];

export const deceasedRelationOptions = [
  { label: 'Employee', value: 'Employee' },
  {
    label: 'Substitutes/other personnel',
    value: 'Substitutes/other personnel',
  },
  {
    label: 'Disablement pensioner',
    value: 'Disablement pensioner',
  },
  {
    label: 'Early retiree',
    value: 'Early retiree',
  },
];

export const deceasedMaritalStatusOptions = [
  { label: 'Married/cohabitant', value: 'Married/cohabitant' },
  {
    label: 'Separated/divoced',
    value: 'Separated/divoced',
  },
  {
    label: 'Disablement pensioner',
    value: 'Disablement pensioner',
  },
  {
    label: 'Unmarried',
    value: 'Unmarried',
  },
];

export const deceasedContactRelationOptions = [
  { label: 'Spouse/Cohabitant', value: 'Spouse/Cohabitant' },
  {
    label: 'Child',
    value: 'Child',
  },
  {
    label: 'Parent',
    value: 'Parent',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];
